export default "__VITE_ASSET__CUPH1n0H__"